module.exports = __webpack_public_path__ + "img/254.317cd14b.png";